'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var WebApiSitecoreConstants = {
    OphalenCollectiviteitKortingenControl: '/apiproxy/centraalbeheer-relatiemanagement-campagne-collectiviteit-v1-ophalencollectiviteitkortingen',
    OphalenWerkgeverControl: '/_vti_bin/CentraalBeheer.Relatiemanagement.Campagne/Campagne.svc/OphalenWerkgever',
    ZoekenWerkgeversControl: '/apiproxy/centraalbeheer-relatiemanagement-campagne-werkgever-v1-zoekenwerkgevers',
    OphalenClaimLight: '/apiproxy/centraalbeheer-schadeparticulier-publiek-claim-v2-ophalentrackentracestatuscodes',
    OphalenVragenboom: '/apiproxy/distributie-direct-skp-claim-V3-3-ophalenvragenbomen',
    OphalenVragenboomStp: '/apiproxy/distributie-direct-skp-claim-V3-3-ophalenvragenbomen',
    IndienenVragenboom: '/apiproxy/distributie-direct-skp-claim-V3-3-indienenvragenboom',
    VerzekeringsKiezer: '/api/v1/json-documents?name=Schade%20melden%20verzekeringskiezer',
    OphalenWachttijden: '/_vti_bin/Achmea.SharePoint.WebApiProxy/Proxy.svc/Achmea.KCC.Communication.OphalenWachttijden',
    SendTemplatedEmail: '/apiproxy/achmea-outputmanagement-emailtemplate-v1-sendtemplatedemail'
};

exports.default = WebApiSitecoreConstants;


//////////////////
// WEBPACK FOOTER
// ./src/lib/core/webapi/web-api-sitecore.constants.js
// module id = 838
// module chunks = 0